module.exports = __webpack_public_path__ + "static/media/snappy-banner.4f154a7b.svg";